import React, {useEffect, useState} from 'react';
import {route} from "../../../../models/route";
import {RouteForm} from "../../../../components/admin/route/RouteForm";
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {routeResultType} from "../../../../types/Api/RouteResultType";
import {routeHydrator} from "../../../../models/hydrator/routeHydrator";
import {Loader} from "../../../../components/admin/Loader";
import {BoxTitle} from "../../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [route, setRoute] = useState(undefined as undefined | route);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/route/${uuid}`) as Promise<routeResultType>;

      setLoading(true);

      result
        .then((r) => {
          setRoute(routeHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader />
      )}

      {!loading && (route || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier une route' : 'Ajouter une route'}/>
          <RouteForm route={route} />
        </>
      )}
    </>
  );
}
